module.exports = __webpack_public_path__ + "static/media/premission-tip.15a11f6b.jpg";